//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const PostContact = async (data:any) => {
    const response = await axios.post(`${baseURL}/contacts`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
      },
    });
    return response.data;
}